
import { useMutation, useQuery } from "@tanstack/react-query";
import { projectService } from "services/projectService";
import { IdForm, FormProjectUpdate, FormProjectStore, FormProjectAttachment } from "types";
import SnackbarUtils from "utils/SnackbarUtils";

export function useProject() {
    const getDetailProject = async (code) => {
        if (!code) return null;
        const data = await projectService.show(code);
        return data;
    };

    const fetchDataDetail = (code, isFetch) => {
        return useQuery({
            queryKey: ['projectDetail', code, isFetch],
            enabled: !!code,
            queryFn: () => getDetailProject(code),
            staleTime: 1000 * 60 * 3,
            // select: (data) => ({
            //     data: data?.data,
            // }),
        });
    }

    const getProjects = async (page = 1) => {
        const data = await projectService.onGetList(page);
        return data;
    };

    const fetchData = (currentPage, isFetch) => {
        return useQuery({
            queryKey: ['projects', currentPage, isFetch],
            queryFn: () => getProjects(currentPage),
            staleTime: 1000 * 60 * 3,
            select: (data) => ({
                data: data?.data,
                totalPage: data?.totalPage ?? 1,
            }),
        });
    }

    const createProj = useMutation({
        mutationFn: (payload: FormProjectStore) => projectService.store(payload),
        onSuccess: async (res) => {
            if (res.statusCode === 201) {
                SnackbarUtils.success(res?.message);
            }
        },
        onError: (err) => {
            console.error("createProj failed", err);
        },
    });

    const updateProj = useMutation({
        mutationFn: (formData: FormProjectUpdate) => projectService.update(formData),
        onSuccess: async (res) => {
            if (res?.statusCode !== 200) {
                SnackbarUtils.error(res?.message ?? "Update project failure!");
            }
            return res;
        },
        onError: (err) => {
            console.error("updateProj failed", err);
        },
    });

    const attachmentProj = useMutation({
        mutationFn: (formData: FormProjectAttachment) => projectService.attachment(formData),
        onSuccess: async (res) => {
            if (res?.statusCode !== 200) {
                SnackbarUtils.error(res?.message ?? "Attachment project failure!");
            }
            return res;
        },
        onError: (err) => {
            console.error("updateProj failed", err);
        },
    });

    const delProj = useMutation({
        mutationFn: (formData: IdForm) => projectService.destroy(formData),
        onSuccess: async (res) => res,
        onError: (err) => {
            console.error("updateProj failed", err);
        },
    });

    return { fetchData, fetchDataDetail, getProjects, createProj, updateProj, delProj, attachmentProj }
}
